module.exports = __webpack_public_path__ + "img/scan.165465b1.svg";